import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=a12b2e90&lang=pug"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports